import chalk from 'chalk'
import log from 'loglevel'
import prefix from 'loglevel-plugin-prefix'

export const initLogger = () => {

  // Setup levels colors
  const colors: { [key: string]: chalk.ChalkFunction } = {
    TRACE: chalk.magenta,
    DEBUG: chalk.cyan,
    INFO: chalk.blue,
    WARN: chalk.yellow,
    ERROR: chalk.red,
  };

  prefix.reg(log)
  log.enableAll()

  prefix.apply(log, {
    format(level, name, timestamp) {
      return `${chalk.gray(`[${timestamp}]`)} ${chalk.yellow('ci-deploy')} ${colors[level.toUpperCase()](level)} ${chalk.green(`${name}:`)}`
    },
  })

  // Set log level from debug variable or set info as default
  if (process.env.CI_TOOLS_DEBUG) {
    // TODO figure out better type guard so i don't have to cast type (not sure if its possible)
    const envDebug: keyof log.LogLevel = Object.keys(log.levels).includes(process.env.CI_TOOLS_DEBUG) ? process.env.CI_TOOLS_DEBUG as keyof log.LogLevel : 'TRACE'
    if (Object.keys(log.levels).includes(envDebug)) {
      log.setLevel(log.levels[envDebug])
    }
  } else {
    log.setLevel(log.levels["INFO"])
  }
}